import dynamic from 'next/dynamic'

const IntNoSSRWrapper = dynamic(() => import('./IntNoSsrWrapF'), {
  ssr: false,
})

export const NoSSRWrapper = IntNoSSRWrapper

